/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    actionBarContainer: "action-bar-container",
    backButton: "back-button",
    container: "container",
    contentBottom: "content-bottom",
    contentTop: "content-top",
    header: "header",
    headerContainer: "header-container",
    headerContainerBorderEnd: "header-container--border-end",
    heading: "heading",
    summary: "summary",
    description: "description",
    headerContent: "header-content",
    headerActions: "header-actions",
    headerActionsEnd: "header-actions--end",
    headerActionsStart: "header-actions--start",
    contentWrapper: "content-wrapper",
    fabContainer: "fab-container",
    footer: "footer",
    footerContent: "footer-content",
    footerActions: "footer-actions",
    footerStart: "footer-start",
    footerEnd: "footer-end",
};
export const IDS = {
    close: "close",
    collapse: "collapse",
};
export const ICONS = {
    close: "x",
    menu: "ellipsis",
    backLeft: "chevron-left",
    backRight: "chevron-right",
    expand: "chevron-down",
    collapse: "chevron-up",
};
export const SLOTS = {
    actionBar: "action-bar",
    alerts: "alerts",
    contentBottom: "content-bottom",
    contentTop: "content-top",
    headerActionsStart: "header-actions-start",
    headerActionsEnd: "header-actions-end",
    headerMenuActions: "header-menu-actions",
    headerContent: "header-content",
    fab: "fab",
    footer: "footer",
    footerEnd: "footer-end",
    footerStart: "footer-start",
    footerActions: "footer-actions",
};
export const HEADING_LEVEL = 3;
//# sourceMappingURL=resources.js.map
